<svelte:head>
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.5/css/bulma.min.css" />
</svelte:head>

<script>

	import { onMount } from 'svelte'

	import Map from './Map.svelte';
	import MapMarker from './MapMarker.svelte';
	import FilterList from './FilterList.svelte'
	import { createMapMarker } from './MapMarker.svelte';
	import {map} from './Map.svelte'

	// Props passed in from main.js
	export let markers = [];
	export let parkwayCoordinates;
	export let mapId;
	export let filterList;
	export let height;

	let toggledFilters = []
	// $: console.log(toggledFilters)
	let visibleMarkers = []

	function toggleMarkers({detail:toggledFilters}) {
		clearMarkers()
		markers.forEach(marker => {
			if (marker.categories.some(c => toggledFilters.includes(c))) {
				let newMarkers = createMapMarker(marker)
				if (marker.coordinates.length > 1) {
					addMapMakers(newMarkers)
				} else {
					addMapMakers([newMarkers])
				}
			}
		})
	}

	function addMapMakers(markers) {
		markers.forEach(m => {
			m.addTo($map)
			visibleMarkers = [...visibleMarkers, m]
		})
	}

	function clearMarkers() {
		visibleMarkers.forEach(m => m.remove())
	}

	let zoom = 9

</script>

<Map lat={38.03085} lon={-78.8579} {zoom} polyline={parkwayCoordinates} {height}>
	<div class="zoom">
		<button class="button is-link" on:click={() => zoom = zoom + 1} aria-label="Zoom in">
			<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 40" x="0px" y="0px"><path d="M8 14.857c-0.005 0-0.010 0-0.016 0-0.631 0-1.143 0.511-1.143 1.143s0.511 1.143 1.143 1.143c0.006 0 0.011 0 0.017 0h15.998c0.005 0 0.010 0 0.016 0 0.631 0 1.143-0.511 1.143-1.143s-0.511-1.143-1.143-1.143c-0.006 0-0.011 0-0.017 0z"/><path d="M17.143 8c0-0.005 0-0.010 0-0.016 0-0.631-0.511-1.143-1.143-1.143s-1.143 0.511-1.143 1.143c0 0.006 0 0.011 0 0.017v-0.001 15.999c0 0.005 0 0.010 0 0.016 0 0.631 0.511 1.143 1.143 1.143s1.143-0.511 1.143-1.143c0-0.006 0-0.011 0-0.017v0.001z"/><path d="M16 0c-8.823 0-15.999 7.177-15.999 15.999s7.177 15.999 15.999 15.999c8.823 0 15.999-7.177 15.999-15.999s-7.177-15.999-15.999-15.999zM16 2.286c7.588 0 13.714 6.127 13.714 13.714s-6.126 13.714-13.714 13.714c-7.588 0-13.714-6.126-13.714-13.714s6.126-13.714 13.714-13.714z"/></svg>
		</button>
		<button class="button is-link" on:click={() => zoom = zoom - 1} aria-label="Zoom out">
			<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 40" x="0px" y="0px"><path d="M16 0c-8.823 0-16 7.177-16 16s7.177 16 16 16c8.823 0 16-7.177 16-16s-7.177-16-16-16zM16 2.286c7.588 0 13.714 6.126 13.714 13.714s-6.126 13.714-13.714 13.714c-7.588 0-13.714-6.126-13.714-13.714s6.126-13.714 13.714-13.714zM8 14.857c-0.005 0-0.010 0-0.016 0-0.631 0-1.143 0.511-1.143 1.143s0.511 1.143 1.143 1.143c0.006 0 0.011 0 0.017 0h15.999c0.005 0 0.010 0 0.016 0 0.631 0 1.143-0.511 1.143-1.143s-0.511-1.143-1.143-1.143c-0.006 0-0.011 0-0.017 0z"/></svg>
		</button>
	</div>
	{#if filterList }
		<FilterList on:toggle={toggleMarkers} filters={filterList} height={height-30}/>
	{/if}
</Map>

<style>
	.zoom {
		z-index: 9;
    position: absolute;
		left: 5px;
    top: 5px;
		display: flex;
		flex-direction: column;
	}
	button {
    padding: 5px;
    border: 0;
    border-radius: 5px;
    background: white;
		outline: none !important;
	}
	button.button.is-link {
		margin: 0;
	}
	button:first-child {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
	}
	button:last-child {
		border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-top: 1px solid #276cda;
	}
	button:last-child svg {
		top: 1px;
	}
	svg {
    width: 1.5rem;
    height: 1.5rem;
    position: relative;
    top: 2px;
		fill: white;
	}
	:global(.button.is-link) {
		transition: background-color 0.25s;
	}
	:global(.button.is-link:hover) {
		transition: background-color 0.25s;
	}
</style>
